import { styled } from "styled-components";

const HomeContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 0;

  z-index: 10;
`;

const TitleDescription = styled.div`
  gap: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 0 1.5rem;
`;

const Title = styled.div`
  display: flex;
  gap: 0.5rem;

  font-weight: 900;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.grotesk};
  svg {
    width: 1.6875rem;
    height: 1.6875rem;
  }
`;

const Description = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  text-align: center;
  font-weight: 500;
  line-height: 140%;
  font-size: 0.875rem;
`;

const LearMore = styled(Description)`
  color: ${({ theme }) => theme.colors.blue};
  display: flex;
  gap: 0.5rem;

  cursor: pointer;
`;

const Score = styled.div<{ $isExpiredScore?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 0 1.5rem;
  opacity: ${({ $isExpiredScore }) => ($isExpiredScore ? 0.5 : 1)};
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 0 1rem;

  & > button {
    width: fit-content;
    align-self: center;
  }
`;

const Address = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  color: ${({ theme }) => theme.colors.black};

  & > p {
    font-family: ${({ theme }) => theme.fonts.manrope};
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.25rem;
  }

  & > svg {
    cursor: pointer;
    &:active {
      transform: scale(1.2);
      transition: ${({ theme }) => theme.transitions.easeAll};
    }
  }
`;

const UserDataRow = styled.div<{ $isOpen: boolean }>`
  position: relative;
  display: flex;
  gap: 1rem;
  z-index: 1;

  & > div {
    &:first-child {
      cursor: pointer;
      position: absolute;

      width: 4.125rem;
      height: 100%;
      opacity: ${({ $isOpen }) => ($isOpen ? 0 : 1)};
      transition: 0.3s all ease;
      z-index: ${({ $isOpen }) => ($isOpen ? -1 : 101)};
    }
  }
`;

const NFTContainer = styled.div`
  position: relative;

  height: 4.125rem;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  border-radius: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.surfaceScores};
  box-shadow: 2px 2px 0px 0px ${({ theme }) => theme.colors.black};
  overflow: hidden;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Lock = styled.div`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;

  width: 1rem;
  height: 1rem;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 0.25rem;
  background: ${({ theme }) => theme.colors.surfaceTertiary};
  color: ${({ theme }) => theme.colors.red};

  & > svg {
    width: 0.66669rem;
    height: 0.66669rem;
  }
`;

const EmptyNFTContainer = styled.div`
  position: relative;
  height: 4.125rem;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  border-radius: 0.75rem;
  border: 1px dashed #beb3a9;
  overflow: hidden;

  & > img {
    width: 2.5625rem;
    height: 2.5625rem;
  }
`;

const Achievements = styled.div<{ $isOpen: boolean }>`
  width: 100%;
  min-height: 4.125rem;
  padding-left: ${({ $isOpen }) => ($isOpen ? 0 : "5.125rem")};
  transition: 0.3s all ease;

  z-index: 100;
  & > div {
    height: 100%;
    justify-content: center;
  }
`;

const TotalScore = styled.div`
  display: flex;
  gap: 0.5rem;
  align-self: center;
  align-items: center;

  & > p {
    color: ${({ theme }) => theme.colors.black};
    font-family: ${({ theme }) => theme.fonts.grotesk};
    font-size: 1rem;
    font-style: normal;
    font-weight: 900;
    line-height: normal;

    &:first-of-type {
      color: ${({ theme }) => theme.colors.black};
    }

    &:last-of-type {
      color: ${({ theme }) => theme.colors.orangeSecondary};
      -webkit-text-stroke: 1px ${({ theme }) => theme.colors.black};
      text-shadow: 1px 1px 0px ${({ theme }) => theme.colors.black};

      font-weight: 900;
      font-size: 1.25rem;
    }
  }
`;
const GetTotalScoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConnectWalletWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;

  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surfaceScores};
  border-radius: 0.5rem;
  gap: 20px;
  .ton-connect {
    background: ${({ theme }) => theme.colors.orange};

    button {
      background: ${({ theme }) => theme.colors.orange};
      div {
        color: ${({ theme }) => theme.colors.black};
      }
    }
    border: 1px solid #2c3034;
    box-shadow: 4px 4px 0px 0px #2c3034;
    border-radius: 1rem;
  }
`;
const ConnectWalletTitle = styled.p`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 700;
  line-height: 19.36px;
  text-align: center;
`;

const ConnectBlock = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  margin: 0 1.5rem;
  align-self: stretch;
  padding: 0.75rem;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.warning};
  background: ${({ theme }) => theme.colors.surfaceNetwork};

  color: #2c3034;
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 1.1375rem */
  > p {
    flex: 1;
    flex-shrink: 1;
  }
  > svg {
    path,
    rect {
      fill: #db8520;
    }
    circle {
      stroke: #db8520;
    }
  }
`;

export default {
  HomeContainer,
  TitleDescription,
  Title,
  Description,
  LearMore,
  Score,
  Body,
  Address,
  UserDataRow,
  Achievements,
  NFTContainer,
  Lock,
  EmptyNFTContainer,
  TotalScore,
  ConnectWalletWrapper,
  ConnectWalletTitle,
  GetTotalScoreContainer,
  ConnectBlock,
};
